import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Loader from "../../../../utils/loader/Loader";
import { toast, ToastContainer } from "react-toastify";

const DirectLogin = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [showMessage, setShowMessage] = useState(false);

  const [searchParams] = useSearchParams();
  let languageId = searchParams.get("lid");
  let token = searchParams.get("token");

  const validateToken = async () => {
    localStorage.clear();
    try {
      const response = await axios.get(
        "https://api-pi.projectinclusion.in/api/Login/validate-token",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.userId !== "") {
        const userId = response?.data?.userId;
        const userTypeId = response?.data?.userTypeId;

        const userResponse = await getUserDataByUserId(userId);
        if (userResponse?.data !== null) {
          localStorage.setItem("token", token);
          localStorage.setItem("id", userId);
          localStorage.setItem("l_id", languageId);
          localStorage.setItem("userTypeId", userTypeId);
          localStorage.setItem("user", JSON.stringify(userResponse?.data));

          setLoader(false);
          navigate("/user/dashboard");
        }
      }

      return response;
    } catch (error) {
      setShowMessage(true);
      toast.error("User expired, Please login again");
      setTimeout(() => {
        navigate("/user/language");
      }, 2000);
      return null;
    } finally {
      setLoader(false);
    }
  };

  const getUserDataByUserId = async (userId) => {
    try {
      const response = await axios.get(
        `https://api-pi.projectinclusion.in/api/Login/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response;
    } catch (error) {
      console.error("Error user response:", error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      validateToken();
    }, 1000);
  }, []);

  return (
    <>
      {loader === true ? (
        <>
          <div
            className="fixed inset-0 flex justify-center items-center bg-white bg-opacity-80"
            style={{ height: "100vh", width: "100vw" }}
          >
            <Loader type="spinningBubbles" color="#2e376c" />
          </div>
        </>
      ) : (
        <>
          <div></div>
        </>
      )}
      {showMessage && <ToastContainer />}
    </>
  );
};

export default DirectLogin;
